@if (isSmallMediumScreen) {
    <p-drawer [(visible)]="menuVisible" [baseZIndex]="100000" (onHide)="onHideSideBar()" styleClass="sidebar-menu" closable="false">
        <ng-template pTemplate="header">
            <div class="flex w-full">
                <div class="flex flex-1 justify-content-start">
                    <brand-logo logoHeight="32"></brand-logo>
                </div>
                <div class="flex flex-1 justify-content-end">
                    <p-button icon="pi pi-times" [rounded]="true" variant="text" severity="secondary" size="small" (click)="onHideSideBar();" />
                </div>
            </div>
        </ng-template>
        <p-panelMenu [model]="menuItems"></p-panelMenu>
    </p-drawer>
}
@else {
    <p-drawer [(visible)]="menuVisible" [modal]="false" (onHide)="onHideSideBar()" styleClass="sidebar-menu" closable="false">
        <ng-template pTemplate="header">
            <div class="flex w-full">
                <div class="flex flex-1 justify-content-start">
                    <brand-logo logoHeight="32"></brand-logo>
                </div>
                <div class="flex flex-1 justify-content-end">
                    <p-button icon="pi pi-times" [rounded]="true" variant="text" severity="secondary" size="small" (click)="onHideSideBar();" />
                </div>
            </div>
        </ng-template>
        <p-menu [model]="menuItems"></p-menu>
    </p-drawer>
}
